import { render, staticRenderFns } from "./ReviewerSave.vue?vue&type=template&id=5049bd3c&scoped=true&"
import script from "./ReviewerSave.vue?vue&type=script&lang=js&"
export * from "./ReviewerSave.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerSave.vue?vue&type=style&index=0&id=5049bd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049bd3c",
  null
  
)

export default component.exports